import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './AdminHeader.styles';

import Button from '../../components/inputs/button/Button';
import Icon from '../../components/common/icon/Icon';

export class AdminHeader extends Component {
  render() {
    return (
      <header className={css(styles.base)}>
        <div className={css(styles.separator)} />
        <div className={css(styles.settings)}>
          <Icon styles={styles.icon} value="alarm" />
          <Link to="/">
            <Button styles={styles.button}>{I18n.t('title')}</Button>
          </Link>
        </div>
      </header>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(null, mapDispatchToProps)(AdminHeader);



// WEBPACK FOOTER //
// ./src/containers/adminheader/AdminHeader.js